import { Stethoscope } from "lucide-react";
import { ThemeToggle } from "@/components/ThemeToggle";

export function PublicShell({ children, practiceName }) {
  return (
    <div className="min-h-screen bg-background bg-radial-fade">
      <div className="absolute inset-0 bg-grid opacity-20 pointer-events-none" />
      <header className="relative z-10 border-b border-border/50 glass">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-5 py-4">
          <div className="flex items-center gap-2">
            <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary text-primary-foreground">
              <Stethoscope className="h-5 w-5" />
            </div>
            <div>
              <div className="text-sm font-bold tracking-tight leading-none">{practiceName || "Practice OS™"}</div>
              <div className="text-[11px] text-muted-foreground">Patient forms</div>
            </div>
          </div>
          <ThemeToggle />
        </div>
      </header>
      <main className="relative z-10 mx-auto max-w-5xl px-5 py-10 sm:py-16">{children}</main>
      <footer className="relative z-10 border-t border-border/50">
        <div className="mx-auto max-w-5xl px-5 py-6 text-center text-xs text-muted-foreground">
          Your information is encrypted in transit and processed under POPIA. © 2026 Practice OS™
        </div>
      </footer>
    </div>
  );
}
